// Central place for build-time feature flags (Create React App requires REACT_APP_ prefix)
export const remindersEnabled = String(process.env.REACT_APP_ENABLE_REMINDERS ?? '').toLowerCase() === 'true';
